// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHealthPlanDeductibleCoverageDto
 */
export interface IHealthPlanDeductibleCoverageDto {
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanDeductibleCoverageDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanDeductibleCoverageDto
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IHealthPlanDeductibleCoverageDto
     */
    is_default?: boolean;
}

/**
 * Check if a given object implements the IHealthPlanDeductibleCoverageDto interface.
 */
export function instanceOfIHealthPlanDeductibleCoverageDto(value: object): value is IHealthPlanDeductibleCoverageDto {
    return true;
}

export function IHealthPlanDeductibleCoverageDtoFromJSON(json: any): IHealthPlanDeductibleCoverageDto {
    return IHealthPlanDeductibleCoverageDtoFromJSONTyped(json, false);
}

export function IHealthPlanDeductibleCoverageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanDeductibleCoverageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'is_default': json['is_default'] == null ? undefined : json['is_default'],
    };
}

export function IHealthPlanDeductibleCoverageDtoToJSON(json: any): IHealthPlanDeductibleCoverageDto {
    return IHealthPlanDeductibleCoverageDtoToJSONTyped(json, false);
}

export function IHealthPlanDeductibleCoverageDtoToJSONTyped(value?: IHealthPlanDeductibleCoverageDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'is_default': value['is_default'],
    };
}

